/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { meHandler } from "src/store/reducers/meSlice";
import AddImageAvatar from "src/components/shared/atoms/addImageAvatar/AddImageAvatar";
import { enqueueSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import KuikTextField from "src/components/shared/atoms/textField/TextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import UPDATE_USER from "src/graphql/mutation/user/updateUser";
import { useMutation } from "@apollo/client";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import expressConfig from "src/config/express.json";
import KuikwitButton from "src/components/shared/atoms/button";
import { FormValuesProps } from "./Types";
import useStyles from "./Styles";

const Details = ({ meQueryResult }: { meQueryResult: any }) => {
  const { classes } = useStyles();
  const [file, setFile] = useState<any>(null);
  const [updloadFileLoading, setUpdloadFileLoading] = useState<any>(false);
  const [newImageUploaded, setNewImageUploaded] = useState(false);
  const [imageError, setImageError] = useState("");
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);

  const dispatch = useDispatch();
  const { me }: any = useSelector((state: any) => state.me);
  const { agentId } = useActiveUserDetail();
  const [preview, setPreview] = useState<any>(null);
  const [initialFormikValues] = useState({ name: "", pname: "", phone: "" });

  useEffect(() => {
    if (meQueryResult && meQueryResult.me) {
      const { picture, number, pseudonym, username } = meQueryResult.me;
      formik.setValues({
        name: username || "",
        pname: pseudonym || "",
        phone: number || "",
      });
      setPreview(picture);
    }
  }, [meQueryResult?.me]);

  const openFileUpload = () => {
    setFile(null);
    setNewImageUploaded(true);
    if (hiddenFileInput.current !== null) {
      hiddenFileInput?.current.click();
    }
  };

  const handleRemovePhoto = async () => {
    try {
      await updateUser({ variables: { id: agentId, picture: "" } });
      setPreview(null);
      setFile(null);
      dispatch(meHandler({ ...me, picture: "" }));
      // enqueueSnackbar is handled by the updateMutationResult useEffect
    } catch (error) {
      console.error("Error removing photo:", error);
    }
  };

  useEffect(() => {
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    setUpdloadFileLoading(true);
    const env = process.env.NODE_ENV || "development";
    const config = expressConfig[env];
    const formData = new FormData();
    formData.append(
      "operations",
      JSON.stringify({
        query:
          "mutation ($file: Upload!, $agentId: ID!) { profileUpload(file: $file, agentId: $agentId) {result,success,error}}",
        variables: { file: null, agentId },
      }),
    );
    formData.append("map", JSON.stringify({ "0": ["variables.file"] }));
    formData.append("0", file);
    let imagePath = preview;
    if (newImageUploaded) {
      fetch(
        `${config.graphql_domain}:${config.port}/${config.graphql_endpoint}`,
        { method: "POST", body: formData },
      )
        .then((response) => response.json())
        .then(({ data }) => {
          if (data.profileUpload.success) {
            imagePath = data.profileUpload.result;
            updateUser({ variables: { id: agentId, picture: imagePath } });
          } else {
            if (data.profileUpload.error.includes("image_size_error")) {
              enqueueSnackbar(data.profileUpload.error, { variant: "error" });
              return;
            }
            enqueueSnackbar("File Upload Failed, Retry", { variant: "error" });
          }
        })
        .then(() => {
          setUpdloadFileLoading(false);
          dispatch(meHandler({ ...me, picture: imagePath }));
        })
        .catch((error) => {
          console.error("Error during file upload:", error);
          enqueueSnackbar("An error occurred during file upload.", {
            variant: "error",
          });
        });
    }
  }, [file]);

  const MAX_FILE_SIZE = 1 * 1024 * 1024;

  const handleSelectImage: any = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const uploadingProfileImage = event.target.files?.[0];
    const val = event.target.value;
    const regex = /(\.jpg|\.jpeg|\.png|\.avif|\.gif|\.webp)$/i;
    if (!regex.exec(val)) {
      setImageError("File type must be JPG, JPEG, PNG, AVIF, GIF or WEBP");
      return;
    }
    if (uploadingProfileImage && uploadingProfileImage.size > MAX_FILE_SIZE) {
      setImageError("File size exceeded 1MB,\nconsider optimizing your image");
      return;
    }
    if (uploadingProfileImage) setFile(uploadingProfileImage);
  };

  useEffect(() => {
    if (imageError) {
      setTimeout(() => setImageError(""), 3000);
    }
  }, [imageError]);

  useEffect(() => {
    if (imageError) enqueueSnackbar(imageError, { variant: "error" });
  }, [imageError]);

  const [
    updateUser,
    {
      loading: updateMutationLoading,
      error: updateMutationError,
      data: updateMutationResult,
    },
  ] = useMutation(UPDATE_USER);

  useEffect(() => {
    if (updateMutationError) {
      enqueueSnackbar(updateMutationError?.message || "Something went wrong", {
        variant: "error",
      });
    }
  }, [updateMutationError]);

  useEffect(() => {
    if (updateMutationResult && updateMutationResult.updateuser?.success) {
      enqueueSnackbar("Profile updated successfully", { variant: "success" });
    }
  }, [updateMutationResult]);

  const formikValidationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "name should consist of atleast 3 chars")
      .required("name is required"),
    phone: Yup.string()
      .min(11, "Number must be at least 11 digits")
      .max(11, "Number must be at least 11 digits"),
  });

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      if (value.length <= 11) {
        formik.setFieldValue("phone", value);
      }
    }
  };

  const handleFormikSubmit = async (
    FormValues: FormValuesProps,
    formikHelpers: any,
  ) => {
    formikHelpers.setSubmitting(false);
    try {
      const newData = {
        id: agentId,
        username: FormValues.name,
        pseudonym: FormValues.pname,
        number: String(FormValues.phone),
      };
      await updateUser({ variables: newData });
      setNewImageUploaded(false);
    } catch (error) {
      formikHelpers.setSubmitting(false);
    } finally {
      setUpdloadFileLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: initialFormikValues,
    validationSchema: formikValidationSchema,
    onSubmit: handleFormikSubmit,
  });

  return (
    <Box className={classes.detailsContainer}>
      {/* Avatar row */}
      <Box className={classes.avatarBox}>
        <Box sx={{ position: "relative" }}>
          <AddImageAvatar
            id="uploadFile"
            onClick={openFileUpload}
            imageUrl={preview}
            avatarClass={classes.avatar}
            circularProgressOverImage={classes.circularProgressOverImage}
            isUploading={updloadFileLoading}
            name={formik.values.name}
          />
          <input
            type="file"
            ref={hiddenFileInput}
            onChange={handleSelectImage}
            id="uploadFile"
            name="uploadFile"
            style={{ display: "none" }}
          />
        </Box>
        <Box className={classes.avatarInfo}>
          <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <Typography
              className={classes.changePhotoBtn}
              onClick={openFileUpload}
            >
              Change photo
            </Typography>
            {preview && (
              <Typography
                className={classes.changePhotoBtn}
                sx={{
                  color: "red !important",
                  cursor: "pointer",
                }}
                onClick={handleRemovePhoto}
              >
                Remove
              </Typography>
            )}
          </Box>
          <Typography className={classes.avatarHint}>
            JPG, JPEG, PNG, AVIF, GIF or WEBP · Max 1MB
          </Typography>
          {imageError && (
            <Typography className={classes.imgErrorText}>
              {imageError}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Fields */}
      <Box className={classes.fieldsContainer}>
        <Box className={classes.fieldBox}>
          <Typography className={classes.fieldLabel}>User Name</Typography>
          <KuikTextField
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            helperText={formik.touched.name && formik.errors.name}
            label="Enter your full name"
          />
        </Box>
        <Box className={classes.fieldBox}>
          <Typography className={classes.fieldLabel}>Display Name</Typography>
          <KuikTextField
            id="pname"
            name="pname"
            value={formik.values.pname}
            onChange={formik.handleChange}
            helperText={formik.touched.pname && formik.errors.pname}
            label="Enter display name"
          />
        </Box>
        <Box className={classes.fieldBox}>
          <Typography className={classes.fieldLabel}>Phone Number</Typography>
          <KuikTextField
            id="phone"
            name="phone"
            value={formik.values.phone}
            onChange={handlePhoneChange}
            helperText={formik.touched.phone && formik.errors.phone}
            label="Enter your contact number"
            typeField="number"
          />
        </Box>
      </Box>

      {/* Save */}
      <Box>
        <KuikwitButton
          type="submit"
          handleClick={formik.handleSubmit}
          className={classes.button}
          variant="contained"
          circular={updateMutationLoading}
        >
          Save Changes
        </KuikwitButton>
      </Box>
    </Box>
  );
};

export default Details;
